// Keep this exhaustive against the locale resources bundled into the learner
// UI. Adding or removing a resource therefore requires an intentional selector
// label update at compile time.
const UI_LANGUAGE_LABELS = {
    sq: 'Albanian – Shqip',
    am: 'Amharic – አማርኛ',
    ar: 'Arabic – عربية',
    bn: 'Bengali – বাংলা',
    bs: 'Bosnian – Bosanski',
    bg: 'Bulgarian – Български',
    'zh-cn': 'Chinese (Simplified)',
    'zh-tw': 'Chinese (Traditional)',
    cs: 'Czech – Čeština',
    da: 'Danish – Dansk',
    nl: 'Dutch – Nederlands',
    en: 'English',
    'en-ca': 'English (Canada)',
    'en-gb': 'English (UK)',
    fi: 'Finnish – Suomi',
    fr: 'French – Français',
    'fr-ca': 'French (Canada)',
    de: 'German – Deutsch',
    el: 'Greek – Ελληνικά',
    ht: 'Haitian Creole – Kreyòl',
    he: 'Hebrew – עברית',
    hi: 'Hindi – हिन्दी',
    hu: 'Hungarian – Magyar',
    id: 'Indonesian – Bahasa Indonesia',
    it: 'Italian – Italiano',
    ja: 'Japanese – 日本語',
    ko: 'Korean – 한국어',
    ms: 'Malay – Bahasa Melayu',
    mr: 'Marathi – मराठी',
    pl: 'Polish – Polski',
    'pt-br': 'Portuguese (Brazil)',
    pa: 'Punjabi – ਪੰਜਾਬੀ',
    ru: 'Russian – Русский',
    sk: 'Slovak – Slovenčina',
    so: 'Somali – Soomaali',
    es: 'Spanish – Español',
    'es-mx': 'Spanish (Mexico)',
    sw: 'Swahili – Kiswahili',
    sv: 'Swedish – Svenska',
    tl: 'Tagalog – Filipino',
    th: 'Thai – ไทย',
    tr: 'Turkish – Türkçe',
    ur: 'Urdu – اردو',
    vi: 'Vietnamese – Tiếng Việt',
};
const LABEL_COLLATOR = new Intl.Collator('en', { sensitivity: 'base' });
export const UI_LANGUAGE_OPTIONS = Object.entries(UI_LANGUAGE_LABELS)
    .map(([locale, label]) => ({ locale: locale, label }))
    .sort((a, b) => {
    if (a.locale === 'en')
        return -1;
    if (b.locale === 'en')
        return 1;
    return LABEL_COLLATOR.compare(a.label, b.label) || a.locale.localeCompare(b.locale, 'en');
});
//# sourceMappingURL=languageCatalog.js.map